import React, { useEffect } from "react";
import { Table  } from 'antd';
import { connect } from "react-redux";
import { 
    getClientTeamList, doClientTeamDelete
} from "../../../../../redux/client/clientState";
import { handleTableChange } from "utils";
import Card from "components/card";

import CrudOption from "components/dropdown/crudoption";
import PopupButton from "components/button/PopupButton";
import ClientTeamForm from "./ClientTeamForm";


const ClientTeamsTable = ({ recordList, pagination, doSearch, filters, doDelete, clientId }) => {

    const columns = [
		{
	        title: `Teams`,
	        dataIndex: 'cte_name',
	        key: 'cte_name',
	        width: '88%',
	        render:(cte_name) => <span>{cte_name}</span> 
	    },
        {
	        title: <PopupButton id="add_client_team" title="Add Client Team" label="Add" btnClass="btn-small">
						<ClientTeamForm recordId={0} mode="edit" clientId={clientId} />
					</PopupButton>,
	        dataIndex: 'cte_id',
	        key: 'cte_id',
	        width: '12%',
	        render:(_, record) => <CrudOption 
                                    baseRoute={`/console/clients/${clientId}/client-teams`} 
                                    recordId={record?.cte_id} 
                                    allowEdit={false}
                                    deleteHandler={() => doDelete({
                                        cte_client_id: record?.cte_client_id,
                                        cte_id: record?.cte_id,
                                    })} 
                                />
	    },
    ]   
	
    
    useEffect(() => {
        if (clientId) {
            doSearch({paginate: pagination.per_page, clientId});
        } 
    }, [doSearch, clientId, pagination.per_page]);

    return (   
        <Card extra={"w-full h-full"}>
            <div className="h-full overflow-x-scroll xl:overflow-x-hidden">
                <Table
                    dataSource={recordList} 
                    columns={columns} 
                    rowKey={(record) => record.cte_id}
                    pagination={{...pagination, 
                        showTotal: (total, range) => `${range[0]} - ${range[1]} of ${total} records`,}}    
                    onChange={handleTableChange(doSearch, filters)}                  	
                />
            </div>
        </Card>
    );
};

const mapStateToProps = (state) => ({
    recordList: state.client.clientTeamList?.items,
    pagination: state.client.clientTeamList?.pagination,
    filters: state.client.clientTeamList?.filters,
    requesting: state.client.clientTeamList?.requesting,
    error: state.client.clientTeamList?.error,
});

const mapDispatchToProps = (dispatch) => ({
    doSearch: (filters) => dispatch(getClientTeamList(filters)),
    doDelete: (id) => dispatch(doClientTeamDelete(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ClientTeamsTable);
